import { render } from "./ProfileCorporate.vue?vue&type=template&id=2eb6be06"
import script from "./ProfileCorporate.vue?vue&type=script&lang=js"
export * from "./ProfileCorporate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__